import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import popupStore from 'src/stores/popup-store';

import { LOCALES, PopupName } from 'src/constants';
import type { CopyToClipboardButtonProps } from './copy-to-clipboard-button.props';

const CopyToClipboardButton = ({ children, url }: CopyToClipboardButtonProps) => {
  const onCopy = () => {
    popupStore.showPopup(PopupName.INFO, {
      title: LOCALES.COPIED,
      text: LOCALES.PAGE_LINK_HAS_BEEN_COPIED,
    });
  };

  return (
    <CopyToClipboard text={url} onCopy={onCopy}>
      {children}
    </CopyToClipboard>
  );
};

export default CopyToClipboardButton;
